export default {
  header: 'Expired Content',
  body: 'The content you are looking for has expired and been removed from your assignment catalog.',
  CTA: 'Return to dashboard',
  modalWidth: '627px',
  icon: 'ALERT',
};
